import { render, staticRenderFns } from "./UserAgreementEditorBase.vue?vue&type=template&id=21162336&scoped=true"
import script from "./UserAgreementEditorBase.vue?vue&type=script&lang=js"
export * from "./UserAgreementEditorBase.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementEditorBase.vue?vue&type=style&index=0&id=21162336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21162336",
  null
  
)

export default component.exports